import { ColumnDef } from "@tanstack/react-table";
import i18next from "i18next";

export const defaultTableColumns: ColumnDef<any, string>[] = [
  {
    accessorKey: "name",
    header: () => i18next.t("billing_columns_name"),
    cell: (info) => info.renderValue(),
    size: 220,
    sortingFn: "text",
  },
  {
    accessorKey: "hospitalPatientId",
    header: () => i18next.t("billing_columns_hospitalId"),
    cell: (info) => info.renderValue(),
    size: 150,
    sortingFn: "text",
  },
  {
    accessorKey: "pmpId",
    header: () => i18next.t("billing_columns_pmpId"),
    cell: (info) => info.renderValue(),
    sortingFn: "basic",
  },
  {
    accessorKey: "numberOfBillableDays",
    header: () => i18next.t("billing_columns_daysRecording"),
    cell: (info) => info.renderValue(),
    sortingFn: "basic",
  },
  {
    accessorKey: "signUpDate",
    header: () => i18next.t("billing_columns_signUpDate"),
    cell: (info) => info.renderValue(),
    size: 160,
    sortingFn: (rowA, rowB) => {
      return (
        rowB.original.signUpdateParsedDate - rowA.original.signUpdateParsedDate
      );
    },
  },
  {
    accessorKey: "lastUsed",
    header: () => i18next.t("billing_columns_lastUsed"),
    cell: (info) => info.renderValue(),
    size: 170,
    sortingFn: (rowA, rowB) => {
      return rowB.original.lastUsedDate - rowA.original.lastUsedDate;
    },
  },
  {
    accessorKey: "dob",
    header: () => i18next.t("billing_columns_dob"),
    cell: (info) => info.renderValue(),
    size: 150,
    enableSorting: false,
  },
  {
    accessorKey: "action",
    header: () => "",
    cell: (info) => info.renderValue(),
    size: 160,
    enableSorting: false,
  },
];
